<header class="nav-wrapper">
  <div class="logo-wrapper">
    <img
      routerLink="/"
      class="logo"
      src="../../../assets/oash-logo-white.svg"
      alt="oash-logo"
    />
  </div>
</header>
